export type AppTelemetryEnv = {
  DEV?: boolean
  MODE?: string
  VITE_APP_ENV?: string
  VITE_POSTHOG_HOST?: string
  VITE_POSTHOG_KEY?: string
  VITE_SENTRY_DSN?: string
}

export type AppTelemetryConfig = {
  environment: string
  posthog: null | {
    host: string
    key: string
  }
  sentry: null | {
    dsn: string
  }
}

function readOptionalString(value: unknown) {
  return typeof value === 'string' && value.trim().length > 0 ? value.trim() : null
}

export function resolveAppTelemetryConfig(
  env: AppTelemetryEnv = import.meta.env as AppTelemetryEnv,
): AppTelemetryConfig {
  const environment = readOptionalString(env.VITE_APP_ENV) ?? env.MODE ?? 'production'

  if (env.DEV) {
    return {
      environment: readOptionalString(env.VITE_APP_ENV) ?? env.MODE ?? 'development',
      posthog: null,
      sentry: null,
    }
  }

  const posthogKey = readOptionalString(env.VITE_POSTHOG_KEY)
  const posthogHost = readOptionalString(env.VITE_POSTHOG_HOST)
  const sentryDsn = readOptionalString(env.VITE_SENTRY_DSN)

  return {
    environment,
    posthog:
      posthogKey && posthogHost
        ? {
            host: posthogHost,
            key: posthogKey,
          }
        : null,
    sentry: sentryDsn ? { dsn: sentryDsn } : null,
  }
}
